import React, { useState } from 'react'
import { Alert, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { useAuth } from '@/middlewares/auth/auth-context'
import { useCreateEvent } from '@/contexts/create-event-context'
import OrganisationDetails from '@/components/MyAccount/OrganisationDetails'
import CreateCompetition from './index'

/**
 * Mounted once in App.js: renders the create-event modal, or the "Complete your organization
 * account" gate (moved from MyCompetitions), according to the CreateEventContext view.
 * OrganisationDetails keeps its legacy callbacks: saving flips the gate to the modal, Cancel closes.
 */
export default function CreateEventHost() {
    const { t } = useTranslation(TranslationNS.MY_COMPETITIONS)
    const authContext = useAuth()
    const { view, setView, close } = useCreateEvent()
    const [error, setError] = useState('')

    if (!view) return null

    if (view === 'create') {
        return (
            <CreateCompetition
                orgaId={authContext.isAdmin ? authContext.userSelect.id : authContext.user.id}
                onClose={close}
            />
        )
    }

    return (
        <Modal
            style={{ width: '250px' }}
            footer={null}
            title={t('Complete your organization account')}
            open={true}
            onCancel={close}
        >
            {error && (
                <Alert
                    style={{ marginBottom: '30px' }}
                    message="Error"
                    description={error}
                    type="error"
                    closable
                    onClose={() => setError('')}
                />
            )}
            <OrganisationDetails
                isModal={true}
                setCreateCompetition={(value) => {
                    if (value) setView('create')
                }}
                setCompleteAccount={(value) =>
                    setView((previous) => (value ? 'gate' : previous === 'gate' ? null : previous))
                }
            />
        </Modal>
    )
}
